type Default = {
	name: string;
	path?: string;
	icon?: string;
	dropDown?: Array<{
		name: string;
		path?: string;
		icon?: string;
		permission?: string;
		isHidden?: boolean;
	}>;
	permission?: string;
	isHidden?: boolean;
};

const Guides: Array<
	Default & {
		dropDown?: Default[];
	}
> = [
		{
			name: 'Dashboard',
			path: 'dashboard',
			icon: 'bi bi-grid',
			permission: '',
		},
		{
			name: 'Appointments',
			path: 'appointments',
			icon: 'bi bi-calendar3',
			permission: 'View Appointment',
		},
		{
			name: 'Queue Management',
			path: 'queue-management',
			icon: 'fa fa-user-plus',
			permission: 'View QMS Per Department',
		},
		{
			name: 'Patients',
			path: 'patients',
			icon: 'fas fa-users',
			permission: 'View Patient List',
		},
		{
			name: 'Antenatal',
			path: 'antenatal',
			icon: 'fas fa-user-shield',
			permission: 'View Antenatal Stats',
			
		},
		{
			name: 'Pharmacy',
			icon: 'fas fa-prescription-bottle-alt',
			permission: 'View Medication Requests',
			dropDown: [
				{
					name: 'Medication',
					permission: 'View Medication Requests',
					icon: 'fas fa-capsules',
					path: 'medications',
				},
				{
					name: "Therapeutic Administration",
					permission: 'View Medication Requests',
					icon: 'fas fa-pills',
					path: 'administrations',
				},
			],
		},

		{
			name: 'Admissions',
			path: 'admissions',
			icon: 'fas fa-hotel',
			permission: 'View Admission',
		},
		{
			name: 'Procedure',
			path: 'procedure',
			icon: 'fas fa-procedures',
			permission: 'View Procedure Requests',
		},

		{
			name: 'Laboratory',
			path: 'labs2',
			icon: 'fas fa-microscope',
			permission: 'View Laboratory V2',
		},
		{
			name: 'Radiology',
			path: 'radiology2',
			icon: 'fas fa-x-ray',
			permission: 'View Radiology V2',
		},
		// {
		// 	name: 'Labs',
		// 	path: 'labs',
		// 	icon: 'fas fa-microscope',
		// 	permission: 'View Lab Test Requests',
		// },

		{
			name: 'Blood Management',
			icon: 'fas fa-tint',
			permission: 'View Blood Bank',
			dropDown: [
				{
					name: 'Blood Request',
					permission: 'View Blood Bank',
					icon: 'fas fa-heartbeat',
					path: 'blood-management',
				},
				{
					name: "External Medical Institution Requests",
					permission: 'View Blood Bank',
					icon: 'fas fa-vial',
					path: 'blood-management/external-institutions',
				},
			],
		},

		// {
		// 	name: 'Radiology',
		// 	path: 'radiology',
		// 	icon: 'fa fa-user-md',
		// 	permission: 'View Radiology Test Requests',
		// },
		{
			name: 'Inventory',
			path: 'inventory',
			icon: 'fas fa-boxes',
			permission: 'View Products',
		},
		{
			name: 'Vendor',
			path: 'vendor',
			icon: 'fa fa-cart-arrow-down',
			permission: 'View Vendors',
		},
		{
			name: 'HMO Management',
			icon: 'fas fa-hospital',
			permission: 'View Health Plan Partner',
			dropDown: [
				{
					name: 'HMO/HPP',
					permission: 'View Health Plan Partner',
					icon: '',
					path: 'hmo-management',
				},
				{
					name: "Approval",
					permission: "View HMO Approvals",
					icon: "",
					path: "hmo-management/approval",
				},

				{
					name: "HMO Bill",
					permission: "View HMO Bills",
					icon: "",
					path: "hmo-management/hmobill",
				},
				{
					name: "Claims",
					permission: "View Claims",
					icon: "",
					path: "hmo-management/claims",
				},
			],
		},
		{
			name: 'Billing & Collection',
			path: 'billing',
			icon: 'fas fa-money-bill',
			permission: 'View Billing Module',
		},
		{
			name: 'Subscription',
			path: 'subscription',
			icon: 'fas fa-credit-card',
			permission: 'View Subscription',
		},
		{
			name: 'Report',
			path: 'report',
			icon: 'bi bi-file-text-fill',
			permission: 'View Report Module',
		},
		{
			name: 'Audit Trail',
			path: 'audit-trail',
			icon: 'fas fa-list-alt',
			permission: 'View Audit Trail',
		},
		// {
		// 	name: 'Administrative',
		// 	path: 'admin',
		// 	icon: 'fas fa-user-shield',
		// 	permission: '',
		// },

		{
			name: 'Settings',
			path: 'settings',
			icon: 'fas fa-cog',
			permission: 'View Settings',
		},		
	];

export default Guides.filter((guide) => !guide?.isHidden);
